const responseParameters = {

  getMethodParameters ({ methodName, finalResponse }) {
    if (responseParameters[methodName + 'Response']) {
      return responseParameters[methodName + 'Response']({ finalResponse })
    } else {
      return finalResponse
    }
  },

  getSrcProfileResponse ({ finalResponse }) {
    let combinedProfiles = { profiles: [] }
    Object.keys(finalResponse).forEach(sdkName => {
      let sdkProfiles = ((finalResponse[sdkName] || {}).response || {}).profiles || []
      if (finalResponse[sdkName].status === 'fulfilled' && sdkProfiles.length > 0) {
        sdkProfiles[0].srcCorrelationId = finalResponse[sdkName].response.srcCorrelationId
        sdkProfiles[0].network = sdkName
        combinedProfiles.profiles.push(...sdkProfiles)
      }
    })
    let sortedCards = responseParameters.getSortedCards({ combinedProfiles })
    return sortedCards
  },
  getSortedCards ({ combinedProfiles }) {
    return combinedProfiles.profiles
      .filter(profile => profile.maskedCards)
      .reduce((cards, profile) => {
        let updatedCards = profile.maskedCards
          .map((card, i, cards) => {
            card.network = profile.network
            card.idToken = profile.authorization || profile.idToken
            card.srcCorrelationId = profile.srcCorrelationId
            return card
          })
        return [...cards, ...updatedCards]
      }, [])
      .sort((card1, card2) => {
        let cardLastUsedDate1 = card1.dateofCardLastUsed || card1.dateOfCardLastUsed || ''
        let cardLastUsedDate2 = card2.dateofCardLastUsed || card2.dateOfCardLastUsed || ''
        if (cardLastUsedDate1.length === 10) {
          cardLastUsedDate1 = cardLastUsedDate1 * 1000
        }
        if (cardLastUsedDate2.length === 10) {
          cardLastUsedDate2 = cardLastUsedDate2 * 1000
        }
        return new Date(cardLastUsedDate2) - new Date(cardLastUsedDate1)
      })
  }
}
export default responseParameters
